import React from 'react';
import SearchResult from "../components/search/SearchResult";
import __ from "./translator";
import styled from "styled-components";

export default function resultRenderFactory(searchQuery, result, index) {
  switch (result.result_type) {
    case 'COLLECTION':
      return (
        <SearchResult
          key={index}
          linkTo={`/seasonal/${result.id}?q=${searchQuery}`}
          cover={result.cover}
          breadcrumb={[__('Seasonal')]}
          title={result.name}
          confidential={result.confidential}>
          <small>{__('Category:')} {__('Seasonal')}</small>
        </SearchResult>
      );

    case 'CATEGORY':
      return (
        <SearchResult
          key={index}
          linkTo={`/timeless/${result.id}?q=${searchQuery}`}
          cover={result.cover}
          breadcrumb={[__('Timeless')]}
          title={result.name}
          confidential={result.confidential}
        >
          <small>{__('Category:')} {__('Timeless')}</small>
        </SearchResult>
      );

    case 'COLLECTION_THEME':
      return (
        <SearchResult
          key={index}
          linkTo={`/seasonal/${result.collection_id}/themes/${result.id}?q=${searchQuery}`}
          cover={result.cover}
          breadcrumb={[__('Seasonal'), result.collection_name]}
          title={result.name}
          confidential={result.confidential}
          furSpecialist={result.fur_specialist}>
          <small>{__('Category:')} {__('Themes')}</small>
        </SearchResult>
      );

    case 'CATEGORY_THEME':
      return (
        <SearchResult
          key={index}
          linkTo={`/timeless/${result.category_id}/themes/${result.id}?q=${searchQuery}`}
          cover={result.cover}
          breadcrumb={[__('Timeless'), result.category_name]}
          title={result.name}
          confidential={result.confidential}
          furSpecialist={result.fur_specialist}
        >
          <small>{__('Category:')} {__('Themes')}</small>
        </SearchResult>
      );

    case 'GLOSSARY':
      return (
        <SearchResult
          key={index}
          linkTo={`/glossary/${result.id}?q=${searchQuery}`}
          cover={result.cover}
          breadcrumb={[__('Glossary')]}
          title={result.name}
          confidential={result.confidential}
          translatedTitle={result.translated_name}
        >
          <GlossaryTermDescription>
            {result.description}
          </GlossaryTermDescription>
        </SearchResult>
      );

    case 'PRODUCT_FOCUS':
      return (
        <SearchResult
          key={index}
          linkTo={`/product-focuses/${result.id}?q=${searchQuery}`}
          cover={result.cover}
          breadcrumb={[__('Product focus')]}
          title={result.name}
          confidential={result.confidential}
          translatedTitle={result.translated_name}
        >
        </SearchResult>
      );

    default:
      return null;
  }
}

const GlossaryTermDescription = styled.p`
  margin-top: 0;
  margin-bottom: 0;
  color: #3e3e3e;
  white-space: pre-wrap;
  font-size: .75rem;
  line-height: 1rem;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
